import { render, staticRenderFns } from "./AdvertisingSettingsView.vue?vue&type=template&id=24f79854"
import script from "./AdvertisingSettingsView.vue?vue&type=script&lang=js"
export * from "./AdvertisingSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports